import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { darkTheme, lightTheme, NConfigProvider } from 'naive-ui';
import { useStore } from 'vuex';

import Header from '@/components/Header.vue';
import SideMenu from '@/components/SideMenu.vue';
import Footer from '@/components/Footer.vue';
import { Theme, key } from '@/store/types';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const themeHash = {
  [Theme.LIGHT]: lightTheme,
  [Theme.DARK]: darkTheme,
};

const store = useStore(key);
const theme = computed(() => themeHash[store.state.theme]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), { theme: _unref(theme) }, {
    default: _withCtx(() => [
      _createVNode(Header),
      _createVNode(SideMenu),
      _createVNode(Footer)
    ]),
    _: 1
  }, 8, ["theme"]))
}
}

})